import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const useSecurityEventExecuteNotificationsCondition = () => {
  const currentUser = useCurrentUser();
  return isPermitted(currentUser.permissions, "security_event:execute_notifications");
};
export default useSecurityEventExecuteNotificationsCondition;
